import Request, { env, filterNullValue, ILogger, mock, transformResponse } from '@ysfe/request'
import { AxiosResponse } from 'axios'

import { envs } from '@/data/envs'

/** 响应数据格式 */
export interface IResponseData {
    message: string
    code: number
    data: any
}

export interface ICreateRequestOptions {
    /** 日志工具 */
    logger: ILogger
    /** 自定义调试环境名 */
    envName?: 'production' | 'pre' | 'test' | 'test2' | 'dev' | 'dev2' | undefined
}

/** 创建请求处理工具 */
export const createRequest = (options: ICreateRequestOptions): Request<IResponseData> => {
    const { logger, envName } = options
    return (
        new Request<IResponseData>({
            withCredentials: true,
            responseType: 'json',
            maxContentLength: 1024 * 4,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
            logger,
            only: true,
            mock: false // 当使用全局 mock 时, 将此项修改为 true
        })
            .use(env(envs, envName)) // 注入环境变量
            .use(mock()) // 注入mock
            .use(filterNullValue(true)) // 注入请求空值过滤
            // 响应处理
            .use(
                transformResponse((status: number, code: number, data: any, response: AxiosResponse) => {
                    // ? http 状态码 >= 400, 表示请求出错. 弹出报错信息即可
                    if (status >= 400) throw new Error('请求出错了')
                    // 成功请求
                    if ([200, 2000, 999999, 0].includes(code)) return
                    // ? 其他的状态码均认定为错误,放在catch中处理
                    if (data) {
                        throw data
                    } else {
                        return Promise.reject({ message: '请求失败' })
                    }
                })
            )
    )
}
